/**
 * Shared configuration for StageSync Documentation
 * Centralizes all environment variables and constants
 */

// Environment variables with fallbacks
export const CONFIG = {
  // API Configuration - Hardcoded for now
  API_BASE_URL: 'https://secure.stagesync.q2q.tech/v3',
  TOKEN_STORAGE_KEY: 'stagesync_api_token',
  APP_UNIQUE_ID: '0001',
  API_TIMEOUT: 30000,
  
  // Feature Flags - Hardcoded
  DEBUG_MODE: false,
  ENABLE_MTLS: true,
  API_CACHE_ENABLED: true,
  API_CACHE_DURATION: 300000, // 5 minutes
  
  // Development Server - Hardcoded
  PORT: 3000,
  HOST: '0.0.0.0',
  HTTPS_ENABLED: false,
  
  // Security Headers - Hardcoded
  CSP_HEADER: "default-src 'self'; script-src 'self' 'unsafe-inline' 'unsafe-eval'; style-src 'self' 'unsafe-inline'; img-src 'self' data: https:; font-src 'self' data:; connect-src 'self' https://secure.stagesync.q2q.tech;",
  CORS_ORIGIN: 'https://docs.stagesync.com',
  
  // Analytics (optional) - Hardcoded
  GA_TRACKING_ID: null,
  SENTRY_DSN: null
};

// Derived configurations
export const DERIVED_CONFIG = {
  // Extract clean API target (remove /v3 suffix)
  CLEAN_API_TARGET: CONFIG.API_BASE_URL.replace(/\/v\d+$/, ''),
  
  // Check if target is HTTPS
  IS_HTTPS_TARGET: CONFIG.API_BASE_URL.startsWith('https://'),
  
  // Check if production environment
  IS_PRODUCTION: import.meta.env.NODE_ENV === 'production' || CONFIG.API_BASE_URL.includes('secure.stagesync.q2q.tech'),
  
  // API endpoints
  ENDPOINTS: {
    VALIDATE_TOKEN: '/api/auth/validate-token',
    // Add other endpoints as needed
  }
};

// Debug logging helper (disabled for production)
export const debugLog = () => {};

// Production-safe logging (disabled for production)
export const productionLog = {
  log: () => {},
  error: () => {},
  warn: () => {}
};

// Validation helpers
export const validateConfig = () => {
  const issues = [];
  
  if (!CONFIG.API_BASE_URL) {
    issues.push('API_BASE_URL is not configured');
  }
  
  if (DERIVED_CONFIG.IS_PRODUCTION && !DERIVED_CONFIG.IS_HTTPS_TARGET) {
    issues.push('Production environment must use HTTPS');
  }
  
  if (issues.length > 0) {
    productionLog.error('Configuration validation failed:', issues);
    return false;
  }
  
  debugLog('Configuration validated successfully');
  return true;
};

export default CONFIG;
